import { actions } from 'react-redux-form';

import { httpGet } from '../../../../utils/api.utils';
import {
    pipInformationFormModel,
    getCircuitPIPInformationDetails,
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/pip-information.settings";

const defaultState = () => ({
    portSpeedOptions: [],
    carrierQosProfileOptions: [],
    voiceCarOptions: [],
    vpnNameOptions: [],
    voiceCarSpeedOptions: [],
    asnNewOrExistingOptions: [],
    siteOfOriginOptions: []
});

const initialState = defaultState();
const formModelName = "inventoryCircuitForm.pipInformation";

export const pipInformationFormInitialState = pipInformationFormModel;

export const pipInformationActions = {
    getCircuitPIPInformationDetails: (circuitId) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitPIPInformationDetails/' + circuitId);

        dispatch({
            type: getCircuitPIPInformationDetails,
            portSpeedOptions: res.portSpeedOptions,
            carrierQosProfileOptions: res.carrierQosProfileOptions,
            voiceCarOptions: res.voiceCarOptions,
            vpnNameOptions: res.vpnNameOptions,
            voiceCarSpeedOptions: res.voiceCarSpeedOptions,
            asnNewOrExistingOptions: res.asnNewOrExistingOptions,
            siteOfOriginOptions: res.siteOfOriginOptions
        });

        if (res.data != null) {
            dispatch(actions.change(`${formModelName}.portSpeed`, res.data.PortSpeed ?? ""));
            dispatch(actions.change(`${formModelName}.carrierQOSProfile`, res.data.CarrierQoSProfile ?? ""));
            dispatch(actions.change(`${formModelName}.asnNumber`, res.data.AsnNumber ?? ""));
            dispatch(actions.change(`${formModelName}.voiceCAR`, res.data.VoiceCar ?? ""));
            dispatch(actions.change(`${formModelName}.routingProtocol`, res.data.RoutingProtocol ?? ""));
            dispatch(actions.change(`${formModelName}.vpnName`, res.data.VpnName ?? ""));
            dispatch(actions.change(`${formModelName}.voiceCARSpeed`, res.data.VoiceCarSpeed ?? ""));
            dispatch(actions.change(`${formModelName}.asnNewOrExisting`, res.data.ASN_NewOrExisting ?? ""));
            dispatch(actions.change(`${formModelName}.siteOfOrigin`, res.data.SiteOfOrigin ?? ""));
        }
    },
    changeFormModel: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value ?? ""));
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitPIPInformationDetails:
            return {
                ...state,
                portSpeedOptions: action.portSpeedOptions,
                carrierQosProfileOptions: action.carrierQosProfileOptions,
                voiceCarOptions: action.voiceCarOptions,
                vpnNameOptions: action.vpnNameOptions,
                voiceCarSpeedOptions: action.voiceCarSpeedOptions,
                asnNewOrExistingOptions: action.asnNewOrExistingOptions,
                siteOfOriginOptions: action.siteOfOriginOptions
            };
        default:
            return state;
    }
};